import { Skeleton } from "@mui/material";
import React from "react";

const StoreHubSkeleton = () => {
  return (
    <div>
      <div className="overflow-x-auto bg-white shadow-md rounded-lg border border-gray-200 mt-6">
        <table className="w-full text-sm text-left text-gray-700 min-w-[1000px]">
          <thead className="text-xs text-gray-500 uppercase bg-gray-50 border-b">
            <tr>
              <th className="px-4 py-3">ID</th>
              <th className="px-4 py-3">Store Name</th>
              <th className="px-4 py-3">Email</th>
              <th className="px-4 py-3"> Token</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3">Reset Password</th>
              <th className="px-4 py-3">Created At</th>
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 5 }).map((_, index) => (
              <tr key={index} className="border-b">
                <td className="px-4 py-3">
                  <Skeleton variant="text" width={30} />
                </td>
                <td className="px-4 py-3">
                  <Skeleton variant="text" width={100} />
                </td>
                <td className="px-4 py-3">
                  <Skeleton variant="text" width={150} />
                </td>
                <td className="px-4 py-3 text-center">
                  <Skeleton variant="circular" width={24} height={24} />
                </td>
                <td className="px-4 py-3">
                  <Skeleton variant="rounded" width={60} height={20} />
                </td>
                <td className="px-4 py-3 text-center">
                  <Skeleton variant="circular" width={24} height={24} />
                </td>
                <td className="px-4 py-3">
                  <Skeleton variant="text" width={120} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StoreHubSkeleton;
